import { useEffect, useState } from 'react';

/**
 * Hook to detect if the component has hydrated on the client
 * Used to defer heavy animations until after initial render
 */
export const useClientHydrated = () => {
  const [isHydrated, setIsHydrated] = useState(false);

  useEffect(() => {
    setIsHydrated(true);
  }, []);

  return isHydrated;
};
